export default "__VITE_ASSET__CK772LPC__"